import React from "react";
import './ItemCountry.css';

interface ItemCountryProps {
    alpha2Code: string;
    name: string;
    description?: string;
    handleclick: () => void;
}

export const ItemCountry: React.FC<ItemCountryProps> = ({
    alpha2Code,
    name,
    description='',
    handleclick
}) => {
    
    return (
        <div onClick={()=>handleclick()} className="ItemCountry-container">
            {alpha2Code.length> 0 && <img width={25} src={`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.3.0/flags/4x3/${alpha2Code}.svg`} alt='agencia aduana' />}
            <div className="smalltext-header">{name}</div>
            {description && description.length>0 && <div className="smalltext">{description}</div>}
        </div>
    )
}